import { useState } from 'react';
import { RenderUnsettledUI } from 'shared/components';
import { AvailabilityFilters } from './availability-filters';
import { useGetCompanyFlexpools } from '../hooks/use-get-company-flexpools';
import { useGetCompanies } from '../../../../hq/hooks/queryHooks/companies/use-get-companies';
import { useSiteDetection } from '../../../hooks';

type AvailabilityFilterDataProviderOptions = {
  isOpen: boolean;
  toggleFilters: () => void;
  handleFiltersChange: (flexPoolIds: string[]) => void;
  currentFilters: string[];
};

export const AvailabilityFilterDataProvider = ({
  isOpen,
  toggleFilters,
  handleFiltersChange,
  currentFilters,
}: AvailabilityFilterDataProviderOptions) => {
  const { site } = useSiteDetection();
  const [companyInput, setCompanyInput] = useState<string>('');
  const companyQueryEnabled = site === 'hq' && companyInput.length >= 3;
  const companiesQuery = useGetCompanies(companyInput, false, undefined, companyQueryEnabled);
  const [company, setCompany] = useState<{ value: string; label: string } | undefined>(undefined);
  const flexpoolsQuery = useGetCompanyFlexpools(company?.value);

  const isSiteOgp = site === 'ogp';
  const isFlexPoolDataFilled = flexpoolsQuery.status === 'success';

  if (isSiteOgp && !isFlexPoolDataFilled) {
    return <RenderUnsettledUI data={flexpoolsQuery} />;
  }

  if (!isOpen) {
    return null;
  }

  return (
    <AvailabilityFilters
      companyFlexPools={flexpoolsQuery.data || { flexPools: [] }}
      companies={companiesQuery.data || []}
      company={company}
      isOpen={isOpen}
      handleCancel={() => toggleFilters()}
      toggleFilters={toggleFilters}
      setCompany={setCompany}
      handleFiltersChange={handleFiltersChange}
      currentFilters={currentFilters}
      setCompanyInput={setCompanyInput}
      companyInput={companyInput}
    />
  );
};
